/* Product Gallery */ 
 $(window).on('load', function() {
  var $gallery = $('.js-gallery');
  
  $gallery.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    dots: true,
    prevArrow: '<span class="gallery-arrow mod-prev"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M14.8562 25.9314L14.1197 25.5L14.8562 25.0686L23.054 20.2664L23.8067 19.8255L23.8067 20.6978V30.3022L23.8067 31.1745L23.054 30.7336L14.8562 25.9314Z" stroke="#331A15"/><path d="M14.7681 25.5L36.0002 25.5" stroke="#331A15"/></svg></span>',
    nextArrow: '<span class="gallery-arrow mod-next"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M35.1436 25.9314L35.8801 25.5L35.1436 25.0686L26.9458 20.2664L26.193 19.8255L26.193 20.6978V30.3022L26.193 31.1745L26.9458 30.7336L35.1436 25.9314Z" stroke="#331A15"/><path d="M35.2322 25.5L14 25.5" stroke="#331A15"/></svg></span>',
    infinite: false // Disable infinite looping
  });

  // Disable previous arrow initially since it's the first slide
  $('.gallery-arrow.mod-prev').addClass('disabled');

  $gallery.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if(nextSlide === slick.slideCount - 1) {
      $('.gallery-arrow.mod-next').addClass('disabled');
      $gallery.slick('slickPause');
    } else {
      $('.gallery-arrow').removeClass('disabled');
    }
  });

  $('.js-gallery').slickLightbox({
    src: 'src',
    itemSelector: '.js-gallery-popup img',
    background: 'rgba(0, 0, 0, .7)'
  });
     });


/* Cookies */ 
document.addEventListener("DOMContentLoaded", function() {
    var acceptCookiesBtn = document.getElementById('accept-cookies');
    var rejectCookiesBtn = document.getElementById('reject-cookies');
    var cookieBanner = document.getElementById('cookie-banner');

    // Check if cookiesAccepted or cookiesRejected exists in localStorage
    var cookiesAccepted = localStorage.getItem('cookiesAccepted');
    var cookiesRejected = localStorage.getItem('cookiesRejected');

    // Show the banner if both cookiesAccepted and cookiesRejected are not set
    if (!cookiesAccepted && !cookiesRejected) {
        cookieBanner.style.display = 'block';
    }

    acceptCookiesBtn.addEventListener('click', function() {
        cookieBanner.style.display = 'none';
        localStorage.setItem('cookiesAccepted', 'true');
    });

    rejectCookiesBtn.addEventListener('click', function() {
        cookieBanner.style.display = 'none';
        localStorage.setItem('cookiesRejected', 'true');
    });
});







/* Div Reload and refresh the div */ 


$(document).ready(function(){
  // Using event delegation with $(document)
  $(document).on('click', '.remove_item', function(){
    setTimeout(function() {
      var url = window.location.href; // Get the URL from the clicked element
      console.log("Updated Url"+url);
      $(".custom_cart").load(url + " .custom_cart > *");
        window.location.reload(true);
    }, 800); // 3 seconds delay in milliseconds
  });
});

$(document).ready(function (){

  setTimeout(function() {
    $('.instafeed-new-layout-wrapper1').slick(
      {
        infinite: true,
        slidesToShow: 4, 
        autoplay: true,
        dots: false,
        slidesToScroll: 1, 
        arrows: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              centerPadding: '40px',
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: true,
              centerPadding: '40px',
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      })

  }, 2500);
});
